import { NavLink } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <style>{`
        .footer {
          --mint: #1abc9c;
          --bg-dark: #1e2d2a;
          --text-muted: #a3b1af;
          --text-light: #cbd5d4;
          
          background: var(--bg-dark);
          color: #ffffff;
          padding: clamp(40px, 8vw, 80px) 20px 30px;
          font-family: 'Montserrat', sans-serif;
          margin-top: auto;
        }

        .footer-container {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(min(100%, 280px), 1fr));
          gap: clamp(30px, 5vw, 60px);
          max-width: 1200px;
          margin: 0 auto;
        }

        .footer-column {
          display: flex;
          flex-direction: column;
          gap: 15px;
        }

        /* Стилі для контейнера логотипу */
        .logo-wrapper {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 10px;
        }

        .logo-img-container {
          width: 50px;
          height: 50px;
          border-radius: 12px;
          overflow: hidden;
          flex-shrink: 0; /* Щоб лого не стискалося */
          box-shadow: 0 4px 15px rgba(26, 188, 156, 0.2);
        }

        .logo-img {
          width: 100%;
          height: 100%;
          object-fit: cover; /* Ідеальне заповнення */
          display: block;
        }

        .footer-h4 {
          font-size: 16px;
          font-weight: 700;
          color: var(--mint);
          text-transform: uppercase;
          letter-spacing: 1.5px;
          margin-bottom: 10px;
        }

        .footer-nav, .contact-list {
          display: flex;
          flex-direction: column;
          gap: 12px;
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .footer-link {
          color: var(--text-light);
          text-decoration: none;
          font-size: 15px;
          transition: all 0.3s ease;
          display: inline-block;
        }

        .footer-link:hover {
          color: var(--mint);
          transform: translateX(5px);
        }

        .contact-item {
          display: flex;
          align-items: flex-start;
          gap: 12px;
          font-size: 14px;
          color: var(--text-light);
          line-height: 1.5;
        }

        .bottom-bar {
          text-align: center;
          margin-top: clamp(40px, 6vw, 70px);
          padding-top: 25px;
          border-top: 1px solid rgba(255, 255, 255, 0.05);
          font-size: 13px;
          color: #657a76;
        }

        @media (max-width: 600px) {
          .footer { text-align: center; }
          .logo-wrapper { 
            justify-content: center; 
            flex-direction: column; /* На дуже вузьких екранах текст під лого */
          }
          .contact-item { justify-content: center; }
          .footer-link:hover { transform: scale(1.05); }
        }
      `}</style>

      <div className="footer-container">
        
        {/* Блок 1: Про клініку */}
        <div className="footer-column">
          <div className="logo-wrapper">
            <div className="logo-img-container">
              <img 
                src="/images/unnamed.jpg" 
                alt="Logo" 
                className="logo-img" 
              />
            </div>
            <span style={{ fontSize: '18px', fontWeight: 700, lineHeight: 1.2 }}>
              Правобережна психіатрична амбулаторія № 1
            </span>
          </div>
          <p style={{ fontSize: '14px', lineHeight: '1.7', color: 'var(--text-muted)' }}>
            Турбота про ваше здоров'я — наш головний пріоритет. 
            Простір, де професіоналізм зустрічається з затишком.
          </p>
        </div>

        {/* Блок 2: Навігація */}
        <div className="footer-column">
          <h4 className="footer-h4">Навігація</h4>
          <nav className="footer-nav">
            <NavLink to="/" className="footer-link">Головна</NavLink>
            <NavLink to="/employees" className="footer-link">Наші спеціалісти</NavLink>
            <NavLink to="/services" className="footer-link">Послуги</NavLink>
            <NavLink to="/reviews" className="footer-link">Відгуки</NavLink>
            <NavLink to="/news" className="footer-link">Новини</NavLink>
            <NavLink to="/clinic" className="footer-link">Контакти</NavLink>
          </nav>
        </div>

        {/* Блок 3: Контакти */}
        <div className="footer-column">
          <h4 className="footer-h4">Зв'язок</h4>
          <div className="contact-list">
            <div className="contact-item">
              <span style={{ color: 'var(--mint)' }}>📍</span> 
              <span>м. Київ, вул. Кирилівська, 103</span>
            </div>
            <div className="contact-item" style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
              <span style={{ color: 'var(--mint)' }}>📞</span>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <a href="tel:+380445038780" className="footer-link">(044) 503-87-80</a>
                <a href="tel:+380956872590" className="footer-link">(095) 687-25-90</a>
              </div>
            </div>
            <div className="contact-item" style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
              <span style={{ color: 'var(--mint)' }}>🕒</span>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span>Пн-Пт: 09:00 — 16:12</span>
                <span style={{ opacity: 0.8, fontSize: '0.9em' }}>Вихідні: Сб, Нд</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bottom-bar">
        <p>
          © {currentYear} КНП "Правобережна психіатрична амбулаторія № 1". 
          Всі права захищені.
        </p>
      </div>
    </footer>
  );
}